import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashVouchersComponent } from './cash-vouchers/cash-vouchers.component';
import { VouchersRoutingModule } from './vouchers-routing.module';
import { MaterialModule } from "../material-module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EmptyRecordModule } from "../share/component/empty-record/empty-record.module";
import { SharedComponentModule } from "../share/component/shared-component.module";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ExternalVouchersComponent } from './external-vouchers/external-vouchers.component';



@NgModule({
    declarations: [
        CashVouchersComponent,
        ExternalVouchersComponent
    ],
    imports: [
        CommonModule,
        VouchersRoutingModule,
        MaterialModule,
        NgxMatSelectSearchModule,
        FormsModule,
        ReactiveFormsModule,
        EmptyRecordModule,
        SharedComponentModule
    ]
})
export class VouchersModule { }
